<template id="app">
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <div>
      <v-alert :type="alert_type" :value="alert" :model-value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header-->
    <header-component :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :component-name="componentsName()" />
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage" :color="primary_code"> </loading>
    <!-- add and edit user master -->
    <v-form>
      <v-card class="v-card-100">
        <v-card-text>
          <v-row >
            <v-col cols="4" sm="4" md="4" lg="4" class="text-left">
              <span>User Basic Details</span>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-text-field hide-details="auto" v-model="first_name" label="First Name*" variant="outlined" type="text" oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/\s+/g, ' ')"></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-text-field hide-details="auto" v-model="last_name" label="Last Name*" variant="outlined" type="text" oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/\s+/g, ' ')"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" sm="4" md="4" lg="4">
              <span></span>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-text-field hide-details="auto" v-model="user_name" label="UserName*" oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/\s+/g, ' ')" variant="outlined" type="text" :disabled="this.$store.state.action === 'edit'"></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-text-field hide-details="auto" v-model="email" label="Email*" variant="outlined" type="text" :rules="emailValidation" @keyup="emailValid(email)" :disabled="this.$store.state.action === 'edit'"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" sm="4" md="4" lg="4">
              <span></span>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-text-field hide-details="auto" v-model="employee_code" label="Employee Code*" variant="outlined" type="text"></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-text-field hide-details="auto" v-model="mobile_number" label="Mobile Number*" variant="outlined" type="text" :rules="mobileNumberValidation" @keyup="checkinkValid(mobile_number)">
                <template v-slot:prepend-inner>+91</template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" sm="4" md="4" lg="4">
              <span></span>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-autocomplete v-model="mapped_location" :items="mapped_location_items" item-title="name" item-value="id" label="Mapped Location*" variant="outlined" multiple> </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" sm="4" md="4" lg="4" class="text-left">
              <span>Other Details</span>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-autocomplete v-model="role" :items="roleItems" item-title="name" item-value="id" label="Role*" variant="outlined" multiple> </v-autocomplete>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-combobox v-model="designation" :items="designation_items" item-title="name" item-value="id" label="Designation*" variant="outlined" > </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" sm="4" md="4" lg="4"></v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-combobox v-model="branch" :items="branch_items" item-title="name" item-value="id" label="Branch*" variant="outlined" > </v-combobox>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="4" sm="4" md="4" lg="4">Create Password</v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-text-field hide-details="auto" v-model="password" label="Password" variant="outlined" type="text"></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-text-field hide-details="auto" v-model="confirm_password" label="Confirm Password" variant="outlined" type="text"></v-text-field>
            </v-col>
          </v-row> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" v-if="this.$store.state.action === 'add' || this.$store.state.action === 'edit'" variant="outlined" @click="cancelForm">Cancel</v-btn>
          <v-btn variant="flat" color="primary" v-if="this.$store.state.action === 'add' " :disabled="!first_name || !last_name || !user_name || !email || !employee_code || !mobile_number || !mapped_location.length || !role.length || !designation  || !branch || !numbervalid || !email_valid_valid" @click="submitDetails">SUBMIT</v-btn>
          <v-btn variant="flat" color="primary" v-if="this.$store.state.action === 'edit'" :disabled="!first_name || !last_name || !user_name || !email || !employee_code || !mobile_number || !mapped_location.length || !role.length || !designation  || !branch" @click="submitEditDetails">SUBMIT</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-card>
</template>
<script>
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
  import Loading from 'vue-loading-overlay';
  // import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    components: {
      HeaderComponent, Loading
    },
    data() {
      return {
        headerText : "",
        alert : false,
        alert_type: 'info',
        alert_message: '',
        first_name: '',
        last_name: '',
        user_name: '',
        email: '',
        mobile_number:'',
        mapped_location: [],
        mapped_location_items:[],
        role: [],
        roleItems: [],
        designation: [],
        designation_items: [],
        branch: [],
        branch_items: [],
        isLoading: false,
        fullPage:true,
        primary_code:'#0275d8',
        item_details: [],
        userIDs:'',
        message:'',
        employee_code: '',
        numbervalid:false,
        email_valid_valid:false,
        warehouse_list:[],
        // password: '',
        // confirm_password: '',
        mobileNumberValidation:[
          v => !!v || 'Mobile number is required', 
          v => /^[0-9]{10}$/.test(v) || 'Mobile number must be 10 digits'
        ],
      }
    },
    computed: {
      emailValidation() {
        return [
          v => !!v || 'Email is required',
          v => /.+@.+\..+/.test(v) || 'Email must be valid (e.g., example@example.com)'
        ];
      },
    },
    async created() {
      this.headerText = this.$store.state.inventoryId;
      this.condition = this.$store.state.action
      this.getUsers()
      this.getDetails()
      if(this.condition === 'edit'){
        const item_details = this.$store.state.lotIds
        this.first_name = item_details.map(item => item.first_name)
        this.last_name = item_details.map(item => item.last_name)
        this.user_name = item_details.map(item => item.username)
        this.email = item_details.map(item => item.email)
        this.mobile_number = item_details.map(item => item.contact_no)
        this.mapped_location = item_details[0].distribution_center_ids
        this.role = item_details[0].roles
        this.designation = item_details.map(item => item.designation)
        this.branch = item_details.map(item => item.branch)
        this.employee_code = item_details.map(item => item.employee_code)
      } 
    },
    methods: {
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.scrollToTop();
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
            this.alert = false;
        }, 3000);
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      getRouterLink() {
        if (this.headerText === "User Master") {
          this.$store.commit("setActiveTab", {
            active_tab:'first_tab'
          });
          return { name: "userMaster" };
        }
      },
      componentsName() {
        if (this.condition === "add") {
          return 'Add User Master';
        } else if (this.condition === "edit"){
          return 'Edit User Master'
        }
      },
      getRouterLinkText() {
        if (this.headerText === "User Master") {
          return this.headerText;
        }
      },
      checkinkValid(value){
        if(value.length === 10){
           this.numbervalid = true;
        }else{
          this.numbervalid = false;
        }
      },
      cancelForm(){
        this.$router.push({ name: "userMaster" });
      },
      getUsers(){
        this.$httpSecured
        .get('/api/v2/users/filter_options')
        .then(response => {
          if (response.data) {
            this.roleItems = this.transformRoles(response.data.roles);
            const temp = this.role
            this.role = []
            this.roleItems.forEach(rol => {
              if(temp.includes(rol.name))
                this.role.push(rol)
            })
            this.designation_items = response.data.designations
            this.branch_items = response.data.branches
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      },
      getDetails() {
        this.$httpSecured
          .get("/api/v1/warehouse/users/fetch_all_info")
          .then(response => {
            if (response.data) {
              this.mapped_location_items = response.data.warehouses
              this.warehouse_list = response.data.warehouses
              const temp = this.mapped_location
              this.mapped_location = []
              this.mapped_location_items.forEach(loc => {
                if(temp.includes(loc.name))
                  this.mapped_location.push(loc)
              })
              // this.mapped_location_items.unshift({name: 'All', id: 0})
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      transformRoles(roles) {
        return roles.map(role => ({
          id: role[0],
          name: role[1],
        }));
      },
      submitDetails(){
        this.isLoading = true
        this.$httpSecured
        .post("/api/v2/users",{
          "user": {
            'first_name' : this.first_name,
            'last_name' : this.last_name,
            'username' : this.user_name,
            'email' : this.email,
            'contact_no' : this.mobile_number,
            'role_ids' : this.role,
            'designation' : this.designation,
            'branch' : this.branch,
            "distribution_center_ids": this.mapped_location,
            'password' : "blubirch123",
            'password_confirmation': 'blubirch123',
            'employee_code' : this.employee_code
          }
        })
        .then(response => {
          if (response.data) {
            this.message = response.data;
            this.$store.commit("setLotIds", {
              lotIds: this.message,
              inventoryId: 'success'
            });
            this.isLoading = false
            this.$router.push({ name: "userMaster" });
            this.loading = false;
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.isLoading = false
          }
        })
        .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
            this.isLoading = false
        });
      },
      submitEditDetails() {
        this.isLoading = true;
        const userID = this.$store.state.lotIds;
        this.userIDs = userID.map(item => item.id);
        const userPayload = {
            'first_name': this.first_name,
            'last_name': this.last_name,
            'username': this.user_name,
            'email': this.email,
            'contact_no': this.mobile_number,
            'role_ids': this.role,
            'designation': this.designation,
            'branch': this.branch,
            "distribution_center_ids": this.mapped_location,
            'password': "blubirch123",
            'password_confirmation': 'blubirch123',
            'employee_code' : this.employee_code
        };
        const sanitizePayload = (payload) => {
          const sanitized = {};
          for (const key in payload) {
              if (payload.hasOwnProperty(key)) {
                  if (key === 'role_ids' || key === 'distribution_center_ids') {
                      sanitized[key] = payload[key];
                  } else {
                      sanitized[key] = Array.isArray(payload[key]) ? payload[key][0] : payload[key];
                  }
              }
          }
          return sanitized;
        };

        const sanitizedUserPayload = sanitizePayload(userPayload);

        this.$httpSecured
          .put(`/api/v2/users/${this.userIDs}`, { user: sanitizedUserPayload })
          .then(response => {
              if (response.data) {
                  this.message = response.data;
                  this.$store.commit("setLotIds", {
                      lotIds: this.message,
                      inventoryId: 'success'
                  });
                  this.isLoading = false;
                  this.cancelForm();
                  this.loading = false;
              } else {
                  this.showAlert("error", "No Data Found");
                  this.loading = false;
                  this.isLoading = false;
              }
          })
          .catch(error => {
            const errorData = error.response.data;
            let errorMessage = '';
            for (const field in errorData) {
                if (errorData.hasOwnProperty(field)) {
                    errorMessage += `${field}: ${errorData[field][0]} `;
                }
            }
            this.showAlert("error", errorMessage.trim());
              this.loading = false;
              this.isLoading = false;
          });
      }
    },
  }
</script>
<style scoped>
  .v-input__prepend-inner{
    margin-top:20px !important ; 
    padding-right: 4px !important;
  }
</style>